module.exports = __webpack_public_path__ + "static/media/mz.aff3b04a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mz.svg
// module id = 725
// module chunks = 0